import React, { useState } from "react";
import { Column, GroupItem, Summary, TotalItem } from "devextreme-react/data-grid";
import { LVGridCabecera } from "../../Componentes/Basicos/LVGridCabecera";
import { PaginaListado } from "../../Componentes/Compuestos/Paginas/PaginaListado";
import LVButtonNuevo from "../../Componentes/Basicos/LVButtonNuevo";
import { function_VEN_CierresDeCaja_Cabecera_ImpresionComandera } from "neftis7_apicaller/src/funciones/VEN/CierresDeCaja/VEN_CierresDeCaja_Cabecera";

export const VEN_CierresDeCaja_ = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const { VEN_CierresDeCaja_Cabecera: { function_VEN_CierresDeCaja_Cabecera_Listar } } = require('neftis7_apicaller');

  const handleDataLoaded = (data) => {
    setData(data);
  };

  const handleOnClickPrint = async (item) => {    
    try {
      await function_VEN_CierresDeCaja_Cabecera_ImpresionComandera(item.IdCierreDeCaja)
    } catch (error) {
      alert(error)
    } finally {
    }
  };

  return (
    <PaginaListado
      Titulo="CIERRES DE CAJA"
      funcion={function_VEN_CierresDeCaja_Cabecera_Listar}
      onDataLoaded={handleDataLoaded}
    >
      {loading && (
        <div className="spinner-overlay">
          <div className="card-body text-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Cargando...</span>
            </div>
          </div>
        </div>
      )}
      <div className="table-responsive">
        <div style={{ display: 'flex', alignItems: 'left', marginTop: '10px', marginBottom: '10px', gap: '20px' }}>
          <LVButtonNuevo Url="/VEN_CierresDeCaja_ModificacionCreacion/--NUEVO--" visible={false} />
        </div>
        {data.length > 0 ? (
          <LVGridCabecera
            AnchoBotonera={60}
            PageSize={11}
            dataSource={data}
            id="gridContainer"
            keyExpr="IdCierreDeCaja"
            urlEdicion="/CierresDeCajaAlta"
            onClickPrint={handleOnClickPrint}
            puedeClonar={false}
            puedeEditar={false}
            puedeMail={false}
          >
            <Summary>
              <TotalItem
                column="IdCierreDeCaja"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`} />

              <TotalItem
                column="FaltanteTotalApertura"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="SobranteTotalApertura"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />

              <TotalItem
                column="FaltanteTotal"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="SobranteTotal"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="SobranteTotalCredito"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="FaltanteTotalCredito"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="SobranteTotalDebito"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="FaltanteTotalDebito"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />

              <TotalItem
                column="TotalVentas"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="TotalCompras"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="TotalRecibos"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="TotalPagos"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />

              <TotalItem
                column="TotalVentasEfectivo"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="TotalVentasTarjetasCredito"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="TotalVentasTarjetasDebito"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="TotalVentasBancos"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="TotalVentasOtros"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />



              <GroupItem
                column="IdCierreDeCaja"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`}
                showInGroupFooter={true} />

              <GroupItem
                column="FaltanteTotalApertura"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="SobranteTotalApertura"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />

              <GroupItem
                column="FaltanteTotal"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="SobranteTotal"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="SobranteTotalCredito"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="FaltanteTotalCredito"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="SobranteTotalDebito"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="FaltanteTotalDebito"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />

              <GroupItem
                column="TotalVentas"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="TotalCompras"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="TotalRecibos"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="TotalPagos"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />

              <GroupItem
                column="TotalVentasEfectivo"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="TotalVentasTarjetasCredito"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="TotalVentasTarjetasDebito"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="TotalVentasBancos"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="TotalVentasOtros"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />

            </Summary>

            <Column caption="Código" dataField="IdCierreDeCaja" width="120" alignment="Right" dataType="number" />
            <Column caption="Fecha" dataField="Fecha" width="150" alignment="Right" dataType="date" format={'dd/MM/yyyy HH:mm'} filterOperations={['between']} />
            <Column caption="Fecha" dataField="FechaSinHora" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} visible={false} />
            <Column caption="Apertura" dataField="FechaApertura" width="120" alignment="Right" dataType="date" format={'dd/MM/yyyy'} />
            <Column caption="Turno" dataField="Turno" width="70" alignment="Right" dataType="number" />
            <Column caption="Terminal" alignment="Center">
              <Column caption="Código" dataField="Terminal" width="70" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="I_Terminal" width="200" alignment="Left" dataType="string" />
            </Column>
            <Column caption="Responsable" alignment="Center">
              <Column caption="Código" dataField="IdPersonaResponsable" width="70" alignment="Right" dataType="number" />
              <Column caption="Descripción" dataField="I_PersonaResponsable" width="200" alignment="Left" dataType="string" />
            </Column>
            <Column caption="Cantidades" alignment="Center">
              <Column caption="Ventas" dataField="CantidadVentas" width="70" alignment="Right" dataType="number" />
              <Column caption="N.C." dataField="CantidadNC" width="200" alignment="Right" dataType="number" />
            </Column>

            <Column caption="Faltantes/Sobrantes" alignment="Center">
              <Column caption="EF.F.Apertura" dataField="FaltanteTotalApertura" width="120" alignment="Right" dataType="number" format="currency" />
              <Column caption="EF.S.Apertura" dataField="SobranteTotalApertura" width="120" alignment="Right" dataType="number" format="currency" />
              <Column caption="EF.F.Cierre" dataField="FaltanteTotal" width="120" alignment="Right" dataType="number" format="currency" />
              <Column caption="EF.S.Cierre" dataField="SobranteTotal" width="120" alignment="Right" dataType="number" format="currency" />
              <Column caption="CR.S.Cierre" dataField="SobranteTotalCredito" width="120" alignment="Right" dataType="number" format="currency" />
              <Column caption="CR.F.Cierre" dataField="FaltanteTotalCredito" width="120" alignment="Right" dataType="number" format="currency" />
              <Column caption="DEB.S.Cierre" dataField="SobranteTotalDebito" width="120" alignment="Right" dataType="number" format="currency" />
              <Column caption="DEB.F.Cierre" dataField="FaltanteTotalDebito" width="120" alignment="Right" dataType="number" format="currency" />
            </Column>

            <Column caption="Totales Operaciones" alignment="Center">
              <Column caption="Ventas" dataField="TotalVentas" width="100" alignment="Right" dataType="number" format="currency" />
              <Column caption="Compras" dataField="TotalCompras" width="100" alignment="Right" dataType="number" format="currency" />
              <Column caption="Recibos" dataField="TotalRecibos" width="100" alignment="Right" dataType="number" format="currency" />
              <Column caption="Pagos" dataField="TotalPagos" width="150" alignment="Right" dataType="number" format="currency" />
            </Column>
            <Column caption="Totales Formas de Pago" alignment="Center">
              <Column caption="Efectivo" dataField="TotalVentasEfectivo" width="100" alignment="Right" dataType="number" format="currency" />
              <Column caption="Crédito" dataField="TotalVentasTarjetasCredito" width="100" alignment="Right" dataType="number" format="currency" />
              <Column caption="Débito" dataField="TotalVentasTarjetasDebito" width="100" alignment="Right" dataType="number" format="currency" />
              <Column caption="Bancos" dataField="TotalVentasBancos" width="150" alignment="Right" dataType="number" format="currency" />
              <Column caption="Otros" dataField="TotalVentasOtros" width="150" alignment="Right" dataType="number" format="currency" />
            </Column>
          </LVGridCabecera>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaListado>
  );
};
